import { fg } from '@atlaskit/platform-feature-flags';
import { type ConfluenceLabel, confluenceLabelsQuery } from '@atlassian/search-client';

import { type CloudConfig } from '../../../../../common/constants/filters/cloud-config/types';
import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Confluence];

const products3PFromConfig = getProducts3PFromConfigForFilter('label');

const getProducts3PFromConfig = () => {
	return fg('enable_labels_filter_confluence_dc_search') ? products3PFromConfig : [];
};

const searchLabels = async (query: string, config: CloudConfig) => {
	if (!config.intl || config.cloudId === undefined) {
		// base on existing interface, can only query contributors with intl
		return [];
	}

	if (fg('enable_labels_filter_confluence_dc_search')) {
		const product = config.product;
		if (product === ProductKeys.ConfluenceDC) {
			return [
				{
					trackingKey: query,
					value: query,
					label: query,
					queryParamValue: query,
					product: config.product,
				},
			];
		}
	}

	const initialLabelsResponse = await confluenceLabelsQuery(config.cloudId, query, 10);

	const suggestedLabels: ConfluenceLabel[] =
		initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
	const otherLabels: ConfluenceLabel[] =
		initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];

	return (
		[...suggestedLabels, ...otherLabels].map((label) => ({
			trackingKey: label.label || '',
			value: label.label || '',
			queryParamValue: label.label || '',
			label: label.label || '',
			product: config.product,
		})) ?? []
	);
};

export const filter = createMultiSelectFilter({
	id: 'label',
	products: [...productKeys1P, ...getProducts3PFromConfig()],
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'labels',
		fetcher: async (queryParams, config) => {
			return queryParams.map((label) => ({
				trackingKey: label,
				value: label,
				queryParamValue: label,
				label: label,
				product: config.product,
			}));
		},
	},
	lookup: {
		fetcher: async (query, config) => {
			return searchLabels(query, config);
		},
	},
});
